declare namespace $ {

	type $mol_link__uri_shm_projects_goal_demo_1 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_demo['uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__external_shm_projects_goal_demo_2 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link['external'] >
	>
	type $mol_link__title_shm_projects_goal_demo_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_goal_demo_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_embed_native__uri_shm_projects_goal_demo_5 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_demo['uri'] >
		,
		ReturnType< $mol_embed_native['uri'] >
	>
	type $mol_embed_native__title_shm_projects_goal_demo_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_embed_native['title'] >
	>
	export class $shm_projects_goal_demo extends $mol_view {
		Open( ): $mol_link
		Frame( ): $mol_embed_native
		uri( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=demo.view.tree.d.ts.map